import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (max-width: ", "px) {\n    display: inherit;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (min-width: ", "px) {\n    display: inherit;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  @media (min-width: ", "px) and (max-width: ", "px) {\n    display: inherit;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from '../breakpoints';
import { warn } from '../helpers/console';

var getPx = function getPx(prop, max) {
  if (max === void 0) {
    max = true;
  }

  if (typeof prop === 'string') {
    if (max) {
      return breakpoints[prop].max;
    } else {
      return breakpoints[prop].min;
    }
  }

  if (typeof prop === 'number') {
    return prop;
  }
}; // CSS shortcuts


var between = function between(abovePx, belowPx) {
  return css(_templateObject(), abovePx, belowPx);
};

var above = function above(abovePx) {
  return css(_templateObject2(), abovePx);
};

var below = function below(belowPx) {
  return css(_templateObject3(), belowPx);
};

var Wrapper = styled.div(_templateObject4(), function (_ref) {
  var $abovePx = _ref.$abovePx,
      $belowPx = _ref.$belowPx;

  if ($abovePx && $belowPx) {
    return between($abovePx, $belowPx);
  }

  if ($abovePx) {
    return above($abovePx);
  }

  if ($belowPx) {
    return below($belowPx);
  }
});

var Show = function Show(_ref2) {
  var above = _ref2.above,
      below = _ref2.below,
      from = _ref2.from,
      to = _ref2.to,
      props = _objectWithoutPropertiesLoose(_ref2, ["above", "below", "from", "to"]);

  if ((above || below) && (from || to)) {
    warn('Show', 'Mixing props from/to and below/above is not supported and may give unexpected results');
  }

  var abovePx, belowPx; // on above we want it to go to the next breakpoint (ie above md means on lg and xl screens)

  if (above) {
    abovePx = getPx(above) + 1; // get the max of breakpoint 'above'
  }

  if (below) {
    belowPx = getPx(below, false) - 1; // get the min of breakpoint 'below'
  }

  if (from) {
    abovePx = getPx(from, false);
  }

  if (to) {
    belowPx = getPx(to);
  } // if we use this component without props then we want it to Show on all screens


  if (above === undefined && below === undefined && from === undefined && to === undefined) {
    abovePx = 1;
  }

  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $abovePx: abovePx,
    $belowPx: belowPx
  }, props));
};

export default Show;